<template>
  <section :class="{'has-danger': errors.has(name)}">
    <label v-if="validation" :for="name">{{ label | translate | capitalize }}</label>
    <div class='input-group bootstrap-timepicker timepicker'>
      <input type='text' class="form-control" :value="start_time ? data.start_time : data.end_time"  v-validate="{ regex: /0[0-9][:][0-5]{1}[0-9]{1}|1[0-9][:][0-5]{1}[0-9]{1}|2[0-3][:][0-5]{1}[0-9]{1}/ }" :name="name" :id="id" />
      <div class="input-group-append style-time">
        <span class="input-group-text">
          <i class="fa fa-clock-o"></i>
        </span>
      </div>
    </div>
    <span v-show="errors.has(name)" class="m-form__help m--font-danger"> {{errors.first(name)}} </span>
  </section>
</template>
<script>
export default {
  props: {
    readonly: { default: true, type: Boolean },
    options: { default: {}, type: Object },
    placeholder: { default: '', type: String },
    data: { default: {}, type: Object },
    start_time: { default: false, type: Boolean },
    name: { default: '', type: String },
    id: { default: '', type: String },
    validation: { default: '', type: String },
    label: { default: '', type: String },
    start_time_visitor: { default: undefined, type: String },
    end_time_visitor: { default: undefined, type: String },
    same_dates: { default: false, type: Boolean }
  },
  data () {
    return {
      is_empty: false
    }
  },
  computed: {
    check_start_time () {
      return this.data.start_time
    },
    check_end_time () {
      return this.data.end_time
    }
  },
  methods: {
    onChange (event) {
      const value = event.target.value.substring(1, 2) === ':' ? `0${event.target.value}` : event.target.value
      if (this.start_time) {
        this.data.start_time = value
        this.$emit('input', this.data.start_time)
      } else {
        this.data.end_time = value
        this.$emit('input', this.data.end_time)
      }
      this.is_empty = true
    },
    input (event) {
      let value = ''
      this.is_empty = this.start_time ? this.data.start_time !== '' : this.data.end_time !== ''
      if (!this.is_empty) {
        value = event.originalEvent ? event.originalEvent.data : event.target.value
        value = parseInt(value.substring(0, 1)) > 2 ? `0${value.substring(0, 1)}` : value
        this.start_time ? this.data.start_time = value : this.data.end_time = value
      } else {
        value = event.target.value
        value = parseInt(value.substring(0, 1)) > 2 ? `0${value}` : value
        this.start_time ? this.data.start_time = value : this.data.end_time = value
      }
      this.is_empty = true
    }
  },
  mounted () {
    const element = window.$(this.$el).timepicker(this.options)
    element.on('change', this.onChange)
    element.on('input', this.input)
    window.$(`#${this.id}`).inputmask('mask', { 'mask': '99:99' })
  },
  destroyed () {
    window.$(this.$el).timepicker('remove')
  },
  watch: {
    check_start_time (newVal, oldVal) {
      if (newVal === '') {
        this.errors.remove(this.name)
      }
    },
    check_end_time (newVal, oldVal) {
      if (this.same_dates) {
        if (this.data.end_time <= this.data.start_time) this.$toast('cannot_lower', 4)
      }
      if (newVal === '') {
        this.errors.remove(this.name)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.style-time
  cursor: pointer
</style>




// WEBPACK FOOTER //
// TimePicker.vue